import { create } from 'zustand';
import { Strategy } from '../types';

interface StrategyState {
    strategies: Strategy[];
    topStrategyIds: string[];
    loading: boolean;
    error: string | null;

    setStrategies: (strategies: Strategy[]) => void;
    setTopStrategyIds: (ids: string[]) => void;
    addStrategy: (strategy: Strategy) => void;
    updateStrategy: (strategyId: string, updates: Partial<Strategy>) => void;
    deleteStrategy: (strategyId: string) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
}

export const useStrategyStore = create<StrategyState>((set) => ({
    strategies: [],
    topStrategyIds: [],
    loading: true,
    error: null,

    setStrategies: (strategies) => set({ strategies, loading: false, error: null }),
    setTopStrategyIds: (ids) => set({ topStrategyIds: ids }),

    addStrategy: (strategy) => set((state) => ({
        strategies: [strategy, ...state.strategies],
    })),

    updateStrategy: (strategyId, updates) => set((state) => ({
        strategies: state.strategies.map((s) =>
            s.id === strategyId ? { ...s, ...updates } : s
        ),
    })),

    deleteStrategy: (strategyId) => set((state) => ({
        strategies: state.strategies.filter((s) => s.id !== strategyId),
    })),

    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error, loading: false }),
}));
